// data is a CSV export of:
// https://docs.google.com/spreadsheets/d/1N-O1Y9CHJ1VOk-cWTbhasGySsKK31KVr4UGpfCwz3mI/edit?gid=1535024988#gid=1535024988
export default `
District,Assembly Member,SB79 Vote,Party
1,Heather Hadwick,Yes,R
2,Chris Rogers,Yes,D
3,James Gallagher,Yes,R
4,Cecilia M. Aguiar-Curry,NVR,D
5,Joe Patterson,Yes,R
6,Maggy Krell,Yes,D
7,Josh Hoover,Yes,R
8,David J. Tangipa,Yes,R
9,Heath Flora,Yes,R
10,Stephanie Nguyen,Yes,D
11,Lori D. Wilson,Yes,D
12,Damon Connolly,No,D
13,Rhodesia Ransom,Yes,D
14,Buffy Wicks,Yes,D
15,Anamarie Ávila Farías,Yes,D
16,Rebecca Bauer-Kahan,NVR,D
17,Matt Haney,Yes,D
18,Mia Bonta,Yes,D
19,Catherine Stefani,Yes,D
20,Liz Ortega,NVR,D
21,Diane Papan,NVR,D
22,Juan Alanis,Yes,R
23,Marc Berman,Yes,D
24,Alex Lee,Yes,D
25,Ash Kalra,Yes,D
26,Patrick J. Ahrens,Yes,D
27,Esmeralda Z. Soria,Yes,D
28,Gail Pellerin,NVR,D
29,Robert Rivas,Yes,D
30,Dawn Addis,NVR,D
31,Joaquin Arambula,Yes,D
32,Stan Ellis,No,R
33,Alexandra M. Macedo,No,R
34,Tom Lackey,NVR,R
35,Jasmeet Kaur Bains,Yes,D
36,Jeff Gonzalez,NVR,R
37,Gregg Hart,No,D
38,Steve Bennett,Yes,D
39,Juan Carrillo,Yes,D
40,Pilar Schiavo,NVR,D
41,John Harabedian,Yes,D
42,Jacqui Irwin,No,D
43,Celeste Rodriguez,NVR,D
44,Nick Schultz,NVR,D
45,James C. Ramos,Yes,D
46,Jesse Gabriel,NVR,D
47,Greg Wallis,No,R
48,Blanca E. Rubio,NVR,D
49,Mike Fong,Yes,D
50,Robert Garcia,Yes,D
51,Rick Chavez Zbur,No,D
52,Jessica M. Caloza,Yes,D
53,Michelle Rodriguez,NVR,D
54,Mark González,Yes,D
55,Isaac G. Bryan,NVR,D
56,Lisa Calderon,NVR,D
57,Sade Elhawary,Yes,D
58,Leticia Castillo,No,R
59,Phillip Chen,Yes,R
60,Corey A. Jackson,Yes,D
61,Tina S. McKinnor,NVR,D
62,"José Luis Solache, Jr.",No,D
63,Natasha Johnson,No,R
64,Blanca Pacheco,No,D
65,Mike A. Gipson,NVR,D
66,Al Muratsuchi,No,D
67,Sharon Quirk-Silva,Yes,D
68,Avelino Valencia,Yes,D
69,Josh Lowenthal,Yes,D
70,Tri Ta,No,R
71,Kate Sanchez,No,R
72,Diane B. Dixon,No,R
73,Cottie Petrie-Norris,No,D
74,Laurie Davies,No,R
75,Carl DeMaio,No,R
76,Dr. Darshana R. Patel,Yes,D
77,Tasha Boerner,No,D
78,Christopher M. Ward,Yes,D
79,Dr. LaShae Sharp-Collins,Yes,D
80,David A. Alvarez,Yes,D
`
